import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict'

// get the duration between date and now
export default function formatDuration(dateObj) {
  const text = formatDistanceToNowStrict(new Date(dateObj), [])
  return text
}